import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import CardDetailsHeaderButton from './CardDetailsHeaderButton'

export default class SaveCardDetailsHeader extends TemplateView {

    constructor({
        replaceCardCallback = () => {},
        rollbackCallback = () => {},
    }) {
        super()

        this.callbacks = {
            replaceCardCallback,
            rollbackCallback,
        }

        this.state = {
            isClear: false,
        }

        this.onStatePropertyChanged('isClear', (isClear) => {
            this.payAnotherCardButton.toggle(!isClear)
            this.rollbackSavedCardButton.toggle(isClear)

            this.$titleArea.text(isClear
                                ? messageResource.getMessage('licenses.card_details.header.title.edit')
                                : messageResource.getMessage('licenses.card_details.header.title.view'))
        })
    }

    templateHtml() {
        return `<div class="cardDetailsHeader">
                    <div class="titleArea"/>
                    <div class="buttonsArea"/>
               </div>`
    }

    afterRender() {
        this.$titleArea = this.find('.titleArea')
        this.$buttonsArea = this.find('.buttonsArea')

        this.payAnotherCardButton = new CardDetailsHeaderButton({
            title: messageResource.getMessage('licenses.card_details.header.buttons.purchase.replace'),
            additionalClass: 'useAnotherCard',
            onClickCallback: this.callbacks.replaceCardCallback,
        }).init(this.$buttonsArea)

        this.rollbackSavedCardButton = new CardDetailsHeaderButton({
            title: messageResource.getMessage('licenses.card_details.header.buttons.purchase.rollback'),
            additionalClass: 'backToSavedCard',
            onClickCallback: this.callbacks.rollbackCallback,
        }).init(this.$buttonsArea)

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/SaveCardDetailsHeader.js